import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/settings/account')({
  head: () => ({
    meta: [{ title: 'Account | Tekst' }],
  }),
});
